import PropTypes from "prop-types";
import React, { Component, Children } from "react";
import ScrollArea from "react-scrollbar";
import omit from "lodash/omit";
import delay from "lodash/delay";
import classnames from "classnames";
import { noop } from "node-noop";

// how long to wait before focusing scroll areas
// covers transition times.
const focusDelay = 750;

export default class ScrollAreaComponent extends Component {
  componentDidMount() {
    this.focusTimeout = setTimeout(() => {
      this.refs.scrollContainer.focus();
    }, focusDelay);
  }

  componentWillUnmount() {
    // give focus back to a different container
    delay(() => {
      const otherScrollContainer = document.querySelector(
        ".scrollable-container",
      );
      if (otherScrollContainer) {
        otherScrollContainer.focus();
      }
    }, focusDelay);

    clearTimeout(this.focusTimeout);
  }

  render() {
    // These aren't typed here because we check in `propTypes`.
    const {
      children,
      className,
      containerClassName,
      horizontal,
      needsModifiedScrollbars,
      onScroll,
    } = this.props;

    let content;

    if (!needsModifiedScrollbars) {
      content = (
        <div
          className={classnames("scrollable-container", className)}
          onScroll={onScroll}
          ref="scrollContainer"
        >
          {Children.map(
            children,
            (child) =>
              // Use `child &&` so we don't attempt to use `React.cloneElement()` with a
              // `null` `child`. Components can return `null` from their `render` methods so
              // this `null` values in `children` *is* expected behavior.
              child &&
              React.cloneElement(
                child,
                omit(
                  this.props,
                  "className",
                  "needsModifiedScrollbars",
                  "onScroll",
                ),
              ),
          )}
        </div>
      );
    } else {
      content = (
        <ScrollArea
          className={classnames("scrollable-container", className)}
          horizontal={horizontal}
          onScroll={onScroll}
          ref="scrollContainer"
          smoothScrolling
        >
          {Children.map(
            children,
            (child) =>
              // Use `child &&` so we don't attempt to use `React.cloneElement()` with a
              // `null` `child`. Components can return `null` from their `render` methods so
              // this `null` values in `children` *is* expected behavior.
              child &&
              React.cloneElement(
                child,
                omit(
                  this.props,
                  "className",
                  "horizontal",
                  "needsModifiedScrollbars",
                  "onScroll",
                ),
              ),
          )}
        </ScrollArea>
      );
    }

    if (!containerClassName) {
      return content;
    }

    return <div className={containerClassName}>{content}</div>;
  }
}

ScrollAreaComponent.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  horizontal: PropTypes.bool,
  nativeClassName: PropTypes.string,
  nativeContainerClassName: PropTypes.string,
  needsModifiedScrollbars: PropTypes.bool.isRequired,
  onScroll: PropTypes.func,
};

ScrollAreaComponent.defaultProps = {
  className: "",
  containerClassName: "",
  horizontal: false,
  onScroll: noop,
};
